export default function ViewImageModal({ isOpen, imageUrl, title, onClose }) {
  if (!isOpen || !imageUrl) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
      <div className="relative w-full max-w-3xl rounded-2xl border border-white/10 bg-white p-3 shadow-2xl">
        <div className="mb-3 flex items-center justify-between gap-3">
          <h3 className="truncate text-lg font-semibold text-gray-800">
            {title || "Image preview"}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full border border-gray-300 bg-white px-3 py-1 text-sm font-semibold text-gray-700 transition hover:bg-gray-100"
          >
            Close
          </button>
        </div>

        <div className="overflow-hidden rounded-xl border border-gray-200 bg-gray-50">
          <img
            src={imageUrl}
            alt={title || "Preview"}
            className="max-h-[75vh] w-full object-contain"
          />
        </div>
      </div>
    </div>
  );
}
